import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

import type { ResultChipType } from './bulkBiddingEvents.const';

const { BULK_BIDDING } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

export const triggerBulkBiddingResultsChipClicked = (chipType: ResultChipType): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BULK_BIDDING,
		customData: { label: chipType },
		name: 'dlr_bulk_bidding_results_chip_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
